module.exports = "https://web-assets-production.autolist.com/_next/static/images/convertible-angled-8a1f8caa51affc3a6be8ad713ff69d82.jpg";